import AddIcon from "@mui/icons-material/AddRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import ContactFieldsRow from "./ContactFieldsRow";
import type { NewContactState } from "./newContactState";
import { addContactAction } from "./newContactState";

interface Props {
  state: NewContactState;
  setState: Dispatch<SetStateAction<NewContactState>>;
}

const ContactDetailsForm = ({ state, setState }: Props) => {
  return (
    <Stack spacing={2.5}>
      <Typography color="textSecondary">
        Add one or more contacts. Everyone you add here will receive the same fund access you configure in the next step
        &mdash; useful for onboarding a group with identical permissions.
      </Typography>
      <Stack spacing={2}>
        {state.contacts.map((contact, index) => (
          <ContactFieldsRow
            key={contact.key}
            contact={contact}
            contactIndex={index}
            removable={state.contacts.length > 1}
            setState={setState}
          />
        ))}
      </Stack>
      <Box>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<AddIcon />}
          onClick={() => setState(addContactAction())}
        >
          Add another contact
        </Button>
      </Box>
    </Stack>
  );
};

export default ContactDetailsForm;
